import { render, staticRenderFns } from "./wlCompanyPup.vue?vue&type=template&id=d138004a&scoped=true&"
import script from "./wlCompanyPup.vue?vue&type=script&lang=js&"
export * from "./wlCompanyPup.vue?vue&type=script&lang=js&"
import style0 from "./wlCompanyPup.vue?vue&type=style&index=0&id=d138004a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d138004a",
  null
  
)

export default component.exports